export default "__VITE_ASSET__DRdepF4B__"